/* globals voc_tc, voc_tcnew, voc_site */
let $ = Voonto.$;
function addNs(ogurl, ns_source) {
  let ns_linkname = (typeof window.voc_tcnew !== 'undefined' && window.voc_tcnew) ? window.voc_tcnew : window.voc_tc;
  return ogurl + '#ns_campaign=rrss-inducido&ns_mchannel=' + window.voc_site + '&ns_source=' + ns_source + '&ns_linkname=' + ns_linkname + '&ns_fee=0';
}

function shareFacebook(target, ogurl) {
  $(target).on('click', function () {
    let url = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(addNs(ogurl, 'fb'));
    window.open(url, "", "toolbar=0, status=0, width=900, height=500");
  });
}

function shareTwitter(target, twurl, twtitle, twvia) {
  $(target).on('click', function () {
    let url = "https://twitter.com/intent/tweet" + "?url=" + encodeURIComponent(addNs(twurl, 'tw'));
    if (twtitle) {
      url = url + "&text=" + encodeURIComponent(twtitle);
    }
    if (twvia) {
      url = url + "&via=" + encodeURIComponent(twvia);
    }
    window.open(url, "", "toolbar=0, status=0,width=650, height=360");
  });
}

function shareGooglePlus(target, ogurl) {
  $(target).on('click', function () {
    let url = "https://plus.google.com/share?url=" + encodeURIComponent(addNs(ogurl, 'gp'));
    window.open(url, "", "toolbar=0, status=0,width=900, height=500");
  });
}

function shareWhatsapp(target, ogurl, ogtitle) {
  let url = 'whatsapp://send?text=' + encodeURIComponent(ogtitle) + ' ' + encodeURIComponent(addNs(ogurl, 'wh'));
  let $target = $(target);
  if ($target.prop('tagName') === 'A') {
    $target.attr('href', url);
  } else {
    $target.on('click', function () {
      window.location.assign(url);
    });
  }

}

function sharePinterest(target, ogurl, ogtitle, ogimage) {
  $(target).on('click', function () {
    let url = "https://pinterest.com/pin/create/bookmarklet/" +
              "?url=" + encodeURIComponent(addNs(ogurl, 'pn'));
    if (ogimage) {
      url = url + "&media=" + encodeURIComponent(ogimage);
    }
    if (ogtitle) {
      url = url + "&description=" + encodeURIComponent(ogtitle);
    }
    window.open(url, "", "toolbar=0, status=0,width=900, height=500");
  });
}

function shareLinkedin(target, ogurl) {
  $(target).on('click', function () {
    let url = "https://www.linkedin.com/shareArticle?mini=true&url=" +
              encodeURIComponent(addNs(ogurl, 'lk'));
    window.open(url, "", "toolbar=0, status=0,width=900, height=500");
  });
}

export function shareMeta() {
  let ogurl = $("meta[property='og:url']").attr("content");
  if (ogurl) {
    let ogtitle = $("meta[property='og:title']").attr("content");
    let ogimage = $("meta[property='og:image']").attr("content");
    let twvia = $("meta[name='twitter:site']").attr("content").replace(/^ *@/, '');
    Logger.info('share links', {ogurl, ogtitle, ogimage, twvia});

    shareFacebook('.voc-share-fb', ogurl);
    shareTwitter('.voc-share-tw', ogurl, ogtitle, twvia);
    shareGooglePlus('.voc-share-gp', ogurl);
    sharePinterest('.voc-share-pi', ogurl, ogtitle, ogimage);
    shareLinkedin('.voc-share-ln', ogurl);
    shareWhatsapp('.voc-share-wa', ogurl, ogtitle);
  }
}

export function shareMetaPortada() {
    $('.redes-sociales-portada').each(function () {
        var $data = $(this);
        var ogurl = $data.data("url");
        var ogtitle = $data.data("title");
        var twvia = 'abc_es';
        if (ogurl) {
            shareFacebook($data.find('.facebook'), ogurl);
            shareTwitter($data.find('.twitter'), ogurl, ogtitle, twvia);
            shareWhatsapp($data.find('a.whatsapp'), ogurl, ogtitle);
        }
    });
}


/*
 export function shareEmbed() {
 $('.voc-share-home').each(function () {
 let $data = $(this);
 let ogurl = $data.data("url");
 if (ogurl) {
 let ogtitle = $data.data("title");
 let twvia = $("meta[name='twitter:site']").attr("content").replace(/ @|@/, '');
 Logger.info('share links', {ogurl, ogtitle, ogimage, twvia});

 shareFacebook($data.find('.facebook'), ogurl);
 shareTwitter($data.find('.twitter'), ogurl, ogtitle, twvia);
 shareWhatsapp($data.find('a.whatsapp'), ogurl, ogtitle);
 }
 });
 }

 export default {
 'shareMeta': shareMeta,
 'shareEmbed': shareEmbed
 };
 */



// WEBPACK FOOTER //
// ./src/scripts/article/sharelinks.js